/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OAuthProviderRequest } from '../../models/o-auth-provider-request';

export interface UpdateOAuthProvider$Params {
  'Active-Tenant-Identifier': string;
  providerName: 'apple' | 'facebook' | 'google';
      body: OAuthProviderRequest
}

export function updateOAuthProvider(http: HttpClient, rootUrl: string, params: UpdateOAuthProvider$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateOAuthProvider.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('providerName', params.providerName, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateOAuthProvider.PATH = '/brands/oauth-providers/{providerName}';
